// assets
import {
    IconBrandChrome,
    IconHelp,
    IconUsers,
    IconTicket,
    IconMessages,
    IconPencil,
    IconUserCheck,
    IconBuilding,
    IconMailbox,
    IconTriangleSquareCircle,
    IconExclamationMark,
    IconBuildingSkyscraper,
    IconAdjustmentsHorizontal,
    IconBellPlus,
    IconSettings,
    IconCapsule,
    IconClockEdit,
    IconBuildingFactory2,
    IconAsset,
    IconPackageExport,
    IconEngine,
    IconAlertTriangle,
    IconDeviceImacCog,
    IconListTree,
    IconCalendarClock,
    IconMessageUser,
    IconZoomExclamation
} from '@tabler/icons-react';

// constant
const icons = {
    IconBrandChrome,
    IconHelp,
    IconUsers,
    IconTicket,
    IconMessages,
    IconPencil,
    IconUserCheck,
    IconBuilding,
    IconMailbox,
    IconTriangleSquareCircle,
    IconExclamationMark,
    IconBuildingSkyscraper,
    IconAdjustmentsHorizontal,
    IconBellPlus,
    IconSettings,
    IconCapsule,
    IconClockEdit,
    IconBuildingFactory2,
    IconAsset,
    IconPackageExport,
    IconEngine,
    IconAlertTriangle,
    IconDeviceImacCog,
    IconListTree,
    IconCalendarClock,
    IconMessageUser,
    IconZoomExclamation
};

// ==============================|| SAMPLE PAGE & DOCUMENTATION MENU ITEMS ||============================== //

const catalog = {
    id: 'catalog-routes',
    title: 'Catálogos',
    type: 'group',
    children: [
        {
            id: 'shift',
            title: 'Turnos',
            type: 'item',
            url: '/catalog/shift',
            icon: icons.IconCalendarClock,
            external: false,
            breadcrumbs: false,
            target: false
        },
        {
            id: 'shift-extra',
            title: 'Tiempo extra',
            type: 'item',
            url: '/catalog/shift-extra',
            icon: icons.IconClockEdit,
            external: false,
            breadcrumbs: false,
            target: false
        },
        {
            id: 'factory',
            title: 'Plantas de producción',
            type: 'item',
            url: '/catalog/factory',
            icon: icons.IconBuildingFactory2,
            external: false,
            breadcrumbs: false,
            target: false
        },
        {
            id: 'production_floor',
            title: 'Pisos de producción',
            type: 'item',
            url: '/catalog/production-floor',
            icon: icons.IconListTree,
            external: false,
            breadcrumbs: false,
            target: false
        },
        {
            id: 'production_line',
            title: 'Sistemas de producción',
            type: 'item',
            url: '/catalog/production-line',
            icon: icons.IconAsset,
            external: false,
            breadcrumbs: false,
            target: false
        },
        {
            id: 'product',
            title: 'Productos',
            type: 'item',
            url: '/catalog/product',
            icon: icons.IconPackageExport,
            external: false,
            breadcrumbs: false,
            target: false
        },
        {
            id: 'machine',
            title: 'Máquinas',
            type: 'item',
            url: '/catalog/machine',
            icon: icons.IconSettings,
            external: false,
            breadcrumbs: false,
            target: false
        },
        {
            id: 'defects_type',
            title: 'Defectos',
            type: 'item',
            url: '/catalog/defects',
            icon: icons.IconZoomExclamation,
            external: false,
            breadcrumbs: false,
            target: false
        },
        {
            id: 'down_time_type',
            title: 'Incidentes',
            type: 'item',
            url: '/catalog/down-time-type',
            icon: icons.IconAlertTriangle,
            external: false,
            breadcrumbs: false,
            target: false
        },
        {
            id: 'correction_types',
            title: 'Motivos de Solicitudes de Corrección',
            type: 'item',
            url: '/catalog/correction-type',
            icon: icons.IconMessageUser,
            external: false,
            breadcrumbs: false,
            target: false
        }
    ]
};

export default catalog;
